export function CriticalErrorFallback() {
  return (
    <div data-testid="critical-error-fallback">
      Unexpected error occured. Try refreshing page or come back later.
    </div>
  );
}
